import get from 'lodash.get';

/**
 * Parses input errors from the error returned by a mutation.
 *
 * Input errors are converted from an array to an object that be used directly
 * with Formik's setErrors function.
 *
 * setErrors(inputErrors);
 */
const parseInputErrors = error => {
  // We have been told by ITGroove there will only ever be one graphQLError in this array
  // and that this is where input validation will be returned
  const inputErrors = get(error, 'graphQLErrors[0].data.inputErrors', []);

  // There are no input errors
  if (inputErrors.length === 0) {
    return null;
  }

  // Convert errors from an array to an object
  return inputErrors.reduce((inputErrorsObject, inputError) => {
    // Regex to convert the field name to sentence case so we can feed it directly to Formik
    // There may be a better solution but this works for now
    const keyRegExp = new RegExp(inputError.key);
    const titleCaseField = inputError.key.replace(/([A-Z])/g, ' $1').replace(/(^\b[a-z])/g, char => char.toUpperCase());
    const prettifyMessage = inputError.message.replace(keyRegExp, titleCaseField);
    inputErrorsObject[inputError.key] = prettifyMessage;
    return inputErrorsObject;
  }, {});
};
const mutationError = error => {
  const { graphQLErrors, networkError } = error;
  // Network errors like loss a loss of connection
  if (networkError !== null) {
    return {
      inputErrors: null,
      isInputError: false,
      isNetworkError: true,
      isServerError: false,
      message: get(networkError, 'message', null),
      code: get(networkError, 'statusCode', 500)
    };
  }

  // Input validation errors (min/max length etc)
  const inputErrors = parseInputErrors(error);
  if (inputErrors) {
    return {
      inputErrors,
      isInputError: true,
      isNetworkError: false,
      isServerError: false,
      message: get(error, 'graphQLErrors[0].message', null)
    };
  }

  // Server errors (500, permissions, business logic)
  return {
    inputErrors: null,
    isInputError: false,
    isNetworkError: false,
    isServerError: true,
    message: get(graphQLErrors, '[0].message', null) || get(graphQLErrors, '[0].data.errorMessage', null),
    code: get(graphQLErrors, '[0].data.code', 401)
  };
};

export default mutationError;
